import EmailRegrex from "_constants/EmailValidationRegrex";

export const FormHelper = {
  renderErrorMsg,
  isStringBlank,
  validateEmail
};

function renderErrorMsg(error) {
  if (error == null) return "";
  else
    switch (error.type) {
      case "required":
        return "Required.";
      case "validateMsDynamicsCases":
        return "MS Dynamic Cases should be a 10-digit number.";
      case "maxLength":
        return "Max length exceeded.";
      case "minLength":
        return "Min length not met.";
      case "corporateEmail":
        return "Only business emails are allowed. Non-corporate personal email addresses are strictly prohibited."
      case "validEmailFormat":
        return "Please enter a valid email."
      case "validateEmvCoRefNum":
        return "Invalid EmvCo Reference Number."
      case "validate":
        return error.message || "Invalid input.";
      default:
        return error.message || "Invalid input.";
    }
}

function isStringBlank(field) {
  if (field != null && field != "" && field.trim() == "") return false;
  else return true;
}

function validateEmail(email) {
  if (email && !email.match(EmailRegrex.validEmailFormat)) {
    console.log("invalid format")
    return false;
  }
  if (email && !email.match(EmailRegrex.coporateEmail)) {
    console.log("non-corporate email address")
    return false;
  }
  console.log("none")
  return true;
}
